import styled from "styled-components"

export const DetailContainer = styled.div`
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  z-index: 1;
`

export const CategoryTitle = styled.h2`
  color: white;
  font-size: 3.4rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  word-wrap: break-word;
  text-align: center;
`

export const CategoryDescription = styled.h3`
  color: white;
  text-align: center;
  font-size: 2.4rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
`

export const CategoryAnchor = styled.a`
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
`
